<div class="background">
  <h2>背景模板管理</h2>
  <div class="background-container">
    <div class="toolbar">
      <button class="primary-btn" @click="triggerUpload" :disabled="uploading">
        {{ uploading ? '上传中...' : '上传背景图' }}
      </button>
      <input
        ref="fileInputRef"
        class="hidden-input"
        type="file"
        accept="image/*"
        @change="handleSelectFile"
      />
    </div>

    <div class="table-container">
      <div v-if="loading" class="loading-wrapper">
        <div class="loading-spinner"></div>
        <span>加载中...</span>
      </div>

      <table v-else class="data-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>展示顺序</th>
            <th>预览</th>
            <th>创建时间</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="templateList.length === 0">
            <td colspan="5" class="empty-text">暂无背景模板</td>
          </tr>
          <tr v-else v-for="item in templateList" :key="item.id">
            <td>{{ item.id }}</td>
            <td class="sort-column">
              <input
                v-model.number="item.sort_order"
                type="number"
                class="sort-input"
                min="0"
                step="1"
                :disabled="sortSavingId === item.id || uploading"
              />
              <button
                type="button"
                class="action-btn save-sort-btn"
                :disabled="sortSavingId === item.id || uploading"
                @click="handleSortSave(item)"
              >
                {{ sortSavingId === item.id ? '保存中…' : '保存' }}
              </button>
            </td>
            <td>
              <img
                v-if="item.image_url"
                :src="item.image_url"
                class="background-img"
                alt="背景图"
                @click="openPreview(item.image_url)"
              />
              <span v-else>无图片</span>
            </td>
            <td>{{ item.created_at || '-' }}</td>
            <td class="action-column">
              <button class="action-btn delete-btn" @click="handleDelete(item)" :disabled="uploading">
                删除
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div v-if="previewVisible" class="preview-mask" @click="closePreview">
    <div class="preview-container" @click.stop>
      <img :src="previewUrl" class="preview-image" alt="完整背景图" />
      <button class="preview-close-btn" @click="closePreview">关闭</button>
    </div>
  </div>
</div>
